import React from "react";
import {Col, Row ,Typography} from 'antd';
const {Title} = Typography;
const TrustedBy = ()=>{
  const trustedLogos = [
    {
      id:1,
     url:"../../images/trusted-by-logo-1.png", 
    },
    {
      id:2,
     url:"../../images/trusted-by-logo-2.png", 
    },
    {
      id:3,
     url:"../../images/trusted-by-logo-3.png", 
    },
    {
      id:4,
     url:"../../images/trusted-by-logo-4.png", 
    }
  ]
return(
<div className="trusted">
  <div className="container">
    <Row>
    <Col sm={24} md={24} lg={24}><Title level={3} align="center" className="trust-heading">Trusted by</Title></Col>
    {trustedLogos.map((val)=>{
      return(
      <Col sm={24} md={12} lg={6} key={val.id} align="center"><img src={val.url} className="img-fluid" alt=""/></Col>  
   ) })}
     
    </Row>
  </div>
</div>

)
}
export default TrustedBy;